var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row p-3 mt-2 shadow-sm bg-white",
      class: { selected: _vm.batch.loteId === _vm.selectedBatch }
    },
    [
      _c("div", { staticClass: "col-11" }, [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "col-2 text-center text-primary" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Número de folio",
                      expression: "'Número de folio'"
                    }
                  ],
                  staticClass: "cursor-pointer",
                  class: { "text-success": _vm.wasCopied },
                  attrs: { "data-cy": "file-number" }
                },
                [_vm._v(" " + _vm._s(_vm.batch.folio) + " ")]
              ),
              !_vm.onlyRead
                ? _c("b-form-checkbox", {
                    on: { change: _vm.selectElement },
                    model: {
                      value: _vm.batch.selected,
                      callback: function($$v) {
                        _vm.$set(_vm.batch, "selected", $$v)
                      },
                      expression: "batch.selected"
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: "Descripción de lote",
                  expression: "'Descripción de lote'"
                }
              ],
              staticClass: "col-5"
            },
            [_c("read-more", { attrs: { text: _vm.batch.descripcionLote } })],
            1
          ),
          _c(
            "div",
            { staticClass: "col-5" },
            [
              _vm.batch.montoMinimo
                ? _c(
                    "vs-chip",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: "Monto Mínimo",
                          expression: "'Monto Mínimo'"
                        }
                      ],
                      staticClass: "mr-4",
                      attrs: { color: "#7d84ad" }
                    },
                    [
                      _c("vs-avatar", { attrs: { icon: "monetization_on" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("amount")(_vm.batch.montoMinimo)) +
                          " "
                      )
                    ],
                    1
                  )
                : _c("vs-avatar", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Sin monto mínimo",
                        expression: "'Sin monto mínimo'"
                      }
                    ],
                    attrs: { color: "danger", icon: "error", size: "small" }
                  }),
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Fecha de Emisión",
                      expression: "'Fecha de Emisión'"
                    }
                  ],
                  staticClass: "mr-4",
                  attrs: { color: "#ff9800" }
                },
                [
                  _c("vs-avatar", { attrs: { icon: "date_range" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("dateFormat")(_vm.batch.fechaCreacion)) +
                      " "
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-1 d-flex justify-center" },
        [
          _vm._t(
            "actions",
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-center align-items-center"
                },
                [
                  !_vm.onlyRead
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "has-permission",
                              rawName: "v-has-permission",
                              value: "ED197",
                              expression: "'ED197'"
                            },
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: "Editar monto mínimo",
                              expression: "'Editar monto mínimo'"
                            }
                          ],
                          staticClass: "btn-icon rounded-circle mr-2",
                          attrs: {
                            variant: "secondary",
                            size: "sm",
                            "data-cy": "open-edit-batch"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.openModalEditBatch($event)
                            }
                          }
                        },
                        [_c("feather-icon", { attrs: { icon: "EditIcon" } })],
                        1
                      )
                    : _vm._e(),
                  !_vm.onlyRead
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "has-permission",
                              rawName: "v-has-permission",
                              value: "ED198",
                              expression: "'ED198'"
                            },
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip",
                              value: "Quitar lote de subasta",
                              expression: "'Quitar lote de subasta'"
                            }
                          ],
                          staticClass: "btn-icon rounded-circle",
                          attrs: {
                            variant: "danger",
                            size: "sm",
                            "data-cy": "delete-auction-batch"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.handleDeleteAuctionBatch(_vm.batch)
                            }
                          }
                        },
                        [_c("feather-icon", { attrs: { icon: "TrashIcon" } })],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            { batch: _vm.batch }
          )
        ],
        2
      ),
      _c(
        "b-modal",
        {
          ref: "edit-batch",
          attrs: {
            title: "Detalles del Lote Nº " + _vm.batch.folio,
            "hide-footer": "",
            "no-close-on-backdrop": ""
          }
        },
        [
          _c("div", { staticClass: "col-12 mt-3" }, [
            _c("div", [
              _c("strong", [_vm._v("Monto mínimo actual")]),
              _c("div", { staticClass: "ml-3" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("amount")(_vm.batch.montoMinimo)) + " "
                )
              ])
            ])
          ]),
          _c("div", { staticClass: "col-12 mt-3" }, [
            _c(
              "div",
              [
                _c("strong", [_vm._v("Nuevo monto mínimo")]),
                _c(
                  "b-form",
                  { attrs: { "data-vv-scope": "batch-form" } },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("b-form-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          attrs: {
                            name: "number",
                            "data-vv-as": "Monto mínimo",
                            state: _vm.errors.has("batch-form.number")
                              ? false
                              : null
                          },
                          model: {
                            value: _vm.newMinimunAmount,
                            callback: function($$v) {
                              _vm.newMinimunAmount = $$v
                            },
                            expression: "newMinimunAmount"
                          }
                        }),
                        _c("b-form-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.errors.first("batch-form.number")) +
                              " "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "b-button",
                  {
                    directives: [
                      {
                        name: "has-permission",
                        rawName: "v-has-permission",
                        value: "ED199",
                        expression: "'ED199'"
                      }
                    ],
                    staticClass: "badge-glow ml-3 mb-5",
                    attrs: {
                      variant: "primary",
                      "data-cy": "attempt-edit-batch",
                      size: "sm",
                      disabled: _vm.disableEditBatchButton
                    },
                    on: {
                      click: function($event) {
                        return _vm.attemptEditBatch()
                      }
                    }
                  },
                  [_vm._v(" Guardar ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }